import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import { useCharacterFolder } from '../../hooks';

import {
  MainImageStyles,
  OverlayStyles,
  PageStyles,
  PageTitleStyles,
  SubtitleStyles,
} from './FindAiScreen.styles';

export const FindAiScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'FindAiScreen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const { getAsset } = useCharacterFolder();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles>
      <IonContent scrollY={false}>
        <OverlayStyles />
        <MainImageStyles>
          <img src={getAsset('find_ai/splash.jpg')} alt="AI Character" />
        </MainImageStyles>
        <div className="content-wrapper">
          <PageTitleStyles
            className="page-title"
            component="h1"
            variant="title-medium"
            align="center"
          >
            Let's make a boyfriend who is
            <br />
            perfect for you!
            <SubtitleStyles variant={'body-large'}>
              We have a lot of AI's that met many
              <br />
              different preferences for each user
            </SubtitleStyles>
          </PageTitleStyles>
          <OnboardingFooter
            buttonSize={'large'}
            buttonRadius="md"
            onContinue={handleNextStep}
          />
        </div>
      </IonContent>
    </PageStyles>
  );
};
